import React from 'react';
import { useLocale } from '../../context/LocaleContext';
import { ArrowRight, Car, ShieldAlert, Siren, TriangleAlert } from 'lucide-react';

const ALERT_ICONS = [TriangleAlert, Car, ShieldAlert, Siren];
const ALERT_COLORS = ['#F97316', '#3B82F6', '#EF4444', '#DC2626'];
const ALERT_BGS = ['rgba(249,115,22,0.08)', 'rgba(59,130,246,0.08)', 'rgba(239,68,68,0.08)', 'rgba(220,38,38,0.10)'];
const ALERT_BORDERS = ['rgba(249,115,22,0.25)', 'rgba(59,130,246,0.25)', 'rgba(239,68,68,0.25)', 'rgba(220,38,38,0.4)'];

// index.tsx'ten ayrıştırıldı — landing "AlertTypes" bölümü
export default function AlertTypes({ L }: any) {
  const { locale, brandName } = useLocale();
  const ALERTS = L.alerts.items.map((a: any, i: number) => ({ ...a, icon: ALERT_ICONS[i], color: ALERT_COLORS[i], bg: ALERT_BGS[i], border: ALERT_BORDERS[i] }));
  return (
    <>
        <section className="py-16 md:py-24 relative">
          <div className="divider-glow mb-16 mx-12" />
          <div className="max-w-5xl mx-auto px-6">
            <div className="text-center mb-16">
              <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#F97316] uppercase tracking-widest font-semibold mb-4">
                {L.alerts.badge}
              </div>
              <h2
                className="reveal reveal-delay-1 text-4xl md:text-5xl font-black text-white mb-4"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {L.alerts.titlePrefix} <span className="gradient-text">{locale === "tr" ? "Uyarı Tipi" : "Alert Types"}</span>
              </h2>
              <p className="reveal reveal-delay-2 text-gray-400 text-lg max-w-xl mx-auto">
                {L.alerts.subtitle}
              </p>
            </div>

            <div className="flex flex-col gap-4">
              {ALERTS.map((a, i) => {
                const AlertIcon = a.icon;
                return (
                <div
                  key={i}
                  id={`alert-card-${i}`}
                  className={`reveal reveal-delay-${i + 1} alert-pill tilt-card rounded-2xl p-6 flex items-center gap-6`}
                  style={{
                    background: a.bg,
                    border: `1px solid ${a.border}`,
                    boxShadow: `0 4px 24px ${a.bg}`,
                  }}
                >
                  <div
                    className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 shadow-lg"
                    style={{ background: `${a.color}22`, border: `1.5px solid ${a.border}` }}
                  >
                    <AlertIcon size={24} style={{ color: a.color }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-1 flex-wrap">
                      <h3 className="text-white font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
                        {a.title}
                      </h3>
                      <span
                        className="text-xs px-2 py-0.5 rounded-full font-semibold"
                        style={{ background: `${a.color}22`, color: a.color, border: `1px solid ${a.border}` }}
                      >
                        {a.priority}
                      </span>
                    </div>
                    <p className="text-gray-400 text-sm">{a.desc}</p>
                  </div>
                  <ArrowRight size={20} className="text-gray-600 shrink-0" />
                </div>
                );
              })}
            </div>
          </div>
        </section>

    </>
  );
}
